interface CardsMock {
  title: string;
  description: string;
  path: string;
}

export const cardsMock: CardsMock[] = [
  {
    title: 'Serviços',
    description:
      'Otimize o processo de prestação de serviços desde a solicitação do serviço até a sua conclusão. Aumente a produtividade e o desempenho em serviços da sua oficina e garanta a satisfação do cliente.',
    path: '/app/operational/tasks',
  },
  {
    title: 'Clientes',
    description: `Na plataforma, você cadastra seus clientes e insere informações como nome, contato, residência, modelo do veículo e ainda pode criar campos personalizados para deixar registrado quais são suas necessidades e como resolvê-las.`,
    path: '/app/customers/list',
  },
  {
    title: 'Peças',
    description:
      'Chega de perder itens ou fazer compras excessivas e não planejadas. Controle todas as informações do seu estoque, envolvendo quantidade de peças, insumos e disponibilidade deles em tempo real.',
    path: '/app/operational/inventory/parts',
  },
  {
    title: 'Contas a Pagar',
    description:
      'Registre todas as despesas que a oficina tem a pagar, como contas de luz, água, telefone, fornecedores, entre outros.',
    path: '/app/financial/billToPay',
  },
  {
    title: 'Contas a Receber',
    description:
      'Acompanhe todo o fluxo de recebimento da oficina e saiba quantas vendas foram feitas em determinado período e qual o valor previsto de faturamento.',
    path: '/app/financial/billToReceiver',
  },
  {
    title: 'Compras',
    description:
      'Gerencie fornecedores, crie uma lista de itens para compras recorrentes e torne o seu processo de compras mais ágil e assertivo.',
    path: '/app/movements/purchases',
  },
];
